/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IViewConstructor } from "../view/IView";

export interface ModuleMetadata {
	commands?: unknown[];
	views?: Array<[string, IViewConstructor, (...props: unknown[]) => JSX.Element]>;
}

export function Module(id: string, metadata: ModuleMetadata = {}): ClassDecorator {
	return (target) => {
		for (const property in metadata) {
			if (Object.prototype.hasOwnProperty.call(metadata, property)) {
				Reflect.defineMetadata(property, metadata[property], target);
			}
		}
	};
}
